
import {
    LOGIN_SUCCESS,
    LOGOUT_SUCCESS,
    LOGOUT_FAIL,
    GET_PROJECTS,
    GET_PROJECTS_OUTGOING,
    ADD_PROJECT_FAVORITE,
    REMOVE_PROJECT_FAVORITE,
    GET_PROJECT_FAVORITES,
    GET_PROJECT,
    CLEAR_PROJECT,
    CLEAR_PROJECTS,
    CREATE_PROJECT,
    EDIT_PROJECT,
    DELETE_PROJECT,
    ARCHIVE_PROJECT,
    GET_COMPANY_PROJECTS,
    SET_PROJ_HIDDEN_HIDE,
    SET_PROJ_VISIBLE,
    SET_PROJ_HIDDEN,
    CLEAR_ALL_DROPS,
    GET_PROJECTS_DROPS,
    SET_PROJECT_DROP,
    TOGGLE_SHOW_HIDDEN_PROJECTS,
    GET_PROJECTS_INCLUDING_HIDDEN,
    SET_PROJECT_VIEWERS
} from "../actions/types";


const initialState = {
    projects: [],
    noProjectsExist: false,
    projectDrops: [],
    company_projects: [],
    project_favorites: [],
    project: {},
    projectDrop: {},
    showHiddenProjects: false,
};

export default function (state = initialState, action) {
    switch (action.type) {
        // ensure no redux values linger between users ----
        case LOGIN_SUCCESS:
        case LOGOUT_SUCCESS:
        case LOGOUT_FAIL:
            return {
                ...initialState,
            }
        // ------------------------------------------------
        case GET_PROJECTS:
        case GET_PROJECTS_INCLUDING_HIDDEN:
        return {
            ...state,
            projects: action.payload.projects,
            noProjectsExist: action.payload.projects.length === 0 ? true : false,
            projectDrops: action.payload.projectDrops
        };
        case GET_COMPANY_PROJECTS:
        return {
            ...state,
            company_projects: action.payload
        };
        case GET_PROJECTS_OUTGOING:
        return {
            ...state,
            projects: action.payload
        };
        case ADD_PROJECT_FAVORITE:
        return {
            ...state,
            project_favorites: action.payload,
        };
        case REMOVE_PROJECT_FAVORITE:
        return {
            ...state,
            project_favorites: action.payload
        };
        case GET_PROJECT_FAVORITES:
        return {
            ...state,
            project_favorites: action.payload
        };
        case GET_PROJECT:
        return {
            ...state,
            project: action.payload.project,
            projectDrop: action.payload.projectDrop
        };
        case SET_PROJECT_VIEWERS:
        return {
            ...state,
            project: {...state.project, viewers: action.payload}
        };
        case CLEAR_PROJECT:
        return {
            ...state,
            project: {},
            projectDrop: {}
        };
        case CLEAR_PROJECTS:
        return {
            ...state,
            projects: [],
            noProjectsExist: false,
        };
        case DELETE_PROJECT:
            return {
                ...state,
                projects: state.projects.filter((projectitem) => projectitem.project_id !== action.payload),
                projectDrops: state.projectDrops.filter((projectitem) => projectitem.project_id !== action.payload),
                project_favorites: state.project_favorites.filter((projectitem) => projectitem.project_id !== action.payload),
                noProjectsExist: state.projects.length <= 1 ? true : false,
                project: {},
                projectDrop: {}
            };
        case SET_PROJ_HIDDEN_HIDE:
            return {
                ...state,
                projects: state.projects.filter((projectitem) => projectitem.project_id !== action.payload),
                projectDrops: state.projectDrops.filter((projectitem) => projectitem.project_id !== action.payload),
                project_favorites: state.project_favorites.filter((projectitem) => projectitem.project_id !== action.payload),
                noProjectsExist: state.projects.length <= 1 ? true : false,
            };
        case SET_PROJ_HIDDEN:
            return {
                ...state,
                projects: state.projects.map((projectitem) => projectitem.project_id !== action.payload ? projectitem : {...projectitem, hidden: true}),
                project_favorites: state.project_favorites.filter((projectitem) => projectitem.project_id !== action.payload)
            };
        case SET_PROJ_VISIBLE:
            return {
                ...state,
                projects: state.projects.map((projectitem) => projectitem.project_id !== action.payload ? projectitem : {...projectitem, hidden: false}),
            };
        case TOGGLE_SHOW_HIDDEN_PROJECTS:
            return {
                ...state,
                showHiddenProjects: !state.showHiddenProjects
            }
        case CREATE_PROJECT:
            return {
                ...state,
                projects: [...state.projects, action.payload.project],
                projectDrops: [...state.projectDrops, action.payload.projectDrop],
                company_projects: [...state.company_projects, action.payload.project],
                project: action.payload.project,
                projectDrop: action.payload.projectDrop,
                noProjectsExist: false,
            };
        case EDIT_PROJECT:
            return {
                ...state,
                projects: state.projects.map(project => project.project_id === action.payload.project.project_id ? action.payload.project : project),
                projectDrops: state.projectDrops.map(projectDrop => projectDrop.project_id === action.payload.projectDrop.project_id ? action.payload.projectDrop : projectDrop),
                project: { ...state.project, ...action.payload.project },
                projectDrop: action.payload.projectDrop
            };
        case CLEAR_ALL_DROPS:
            return {
                ...state,
                projectDrops: [],
            };
        case SET_PROJECT_DROP:
            return {
                ...state,
                projectDrop: action.payload,
            };
        default:
            return state;
    }
}